module.exports = __webpack_public_path__ + "sk-trip-wizard-mockup-with-shadow@2x.38WDaBSO.png";